export type LegacyShootingStatisticsRow = {
  office: string
  team: string
  staff: string
  total: number
  complete: number
  incomplete: number
  cameraA: number
  cameraB: number
  directorA: number
  directorB: number
}

export const legacyShootingStatisticsRows: LegacyShootingStatisticsRow[] = [
  { office: 'Mock 지점 01', team: '촬영', staff: 'Mock 촬영자 A', total: 18, complete: 15, incomplete: 3, cameraA: 8, cameraB: 7, directorA: 0, directorB: 0 },
  { office: 'Mock 지점 01', team: '연출', staff: 'Mock 연출자 A', total: 15, complete: 12, incomplete: 3, cameraA: 0, cameraB: 0, directorA: 7, directorB: 5 },
  { office: 'Mock 지점 02', team: '촬영', staff: 'Mock 촬영자 B', total: 12, complete: 10, incomplete: 2, cameraA: 6, cameraB: 4, directorA: 0, directorB: 0 },
]

export const legacyShootingGroups = ['Mock 그룹 A', 'Mock 그룹 B']
export const legacyShootingOffices = ['Mock 지점 01', 'Mock 지점 02']
